import { Component, ViewChild,EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CopyPasteComponent } from './copy-paste/copy-paste.component';
import { CsvExcelComponent } from './csv-excel/csv-excel.component';
import { MultipleLineComponent } from './multiple-line/multiple-line.component';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-quick-add',
  templateUrl: './quick-add.component.html',
  styleUrls: ['./quick-add.component.less']
})
export class QuickAddComponent implements OnInit {
  tabSelectedIndex: number = 0;
  isValid: boolean = true;
  isDealerPortal: boolean = false;
  @Input() isModal: boolean = false;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild(MultipleLineComponent) multipleLineComponent: MultipleLineComponent | undefined;
  @ViewChild(CopyPasteComponent) copyPasteComponent: CopyPasteComponent | undefined;
  @ViewChild(CsvExcelComponent) csvExcelComponent: CsvExcelComponent | undefined;
  constructor(private sharedData: SharedDataService) {
    this.sharedData.currentData.subscribe(data => {
      this.isDealerPortal = data.isDealerPortal;
    });
  }
  ngOnInit(): void {
  }
  onTabChange(index: number) {
    this.tabSelectedIndex = index;
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      if (index === 0) {
        (window as any).dataLayer.push({
          event: 'dp_quick_add',
          from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
          event_type: 'multiple line',
          event_name: '',
          portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
          event_content: '',
        });
      }
      if (index === 1) {
        (window as any).dataLayer.push({
          event: 'dp_quick_add',
          from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
          event_type: 'copy paste',
          event_name: '',
          portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
          event_content: '',
        });
      }
      if (index === 2) {
        (window as any).dataLayer.push({
          event: 'dp_quick_add',
          from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
          event_type: 'CSV and excel',
          event_name: '',
          portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
          event_content: '',
        });
      }
    }
  }
  addToCart(){
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_add_to_cart_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: 'quick add',
        event_name: 'add to cart',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: '',
      });
    }
    if(this.tabSelectedIndex==0){
      this.multipleLineComponent?.addToCart();
    }else if(this.tabSelectedIndex==1){
      this.copyPasteComponent?.checkValue();
    }else if(this.tabSelectedIndex==2){
      this.csvExcelComponent?.addToCart();
    }
  }
  closeAddModal(){
    this.closeModal.emit();
  }
  setIsValid(isValid:boolean): void {
    this.isValid = isValid;
  }
}
